import axios from 'axios';
import { getByKey } from '../session-storage/session-storage.service';

export const initInterceptor = () => {
  const TOKEN_KEY: string = 'AccessToken';
  const publicEndpoints = ['/api/Languages', '/api/Pirs'];

  function setHeaders(config: any, token: string) {
    config.headers = {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    };
  }

  axios.interceptors.request.use(
    function (config: any) {
      if (publicEndpoints.some(url => config.url?.includes(url))) {
        return Promise.resolve(config);
      }
      const token: string = getByKey(TOKEN_KEY);  
      if (token) setHeaders(config, token);
      return Promise.resolve(config);
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
};
